const en = {
    general: {
        notAvailable: 'N/A',
    },
    common: {
        today: 'Today',
    },
    tableRanges: {
        start: 'Start',
        end: 'End',
        month: 'Month',
        hour: 'Hour',
    },
    months: {
        short: {
            jan: 'Jan',
            feb: 'Feb',
            mar: 'Mar',
            apr: 'Apr',
            may: 'May',
            jun: 'Jun',
            jul: 'Jul',
            aug: 'Aug',
            sep: 'Sep',
            oct: 'Oct',
            nov: 'Nov',
            dec: 'Dec',
        },
    },
    hello: 'Hello',
    header: {
        title: 'Energy Management System',
        search: 'Search...',
        superUser: 'Super User',
        back: 'Back',
        profile: {
            profile: 'Profile',
            settings: 'Settings',
            myAccount: 'My Account',
            logout: 'Logout',
        },
    },
    login: {
        email: 'Email',
        password: 'Password',
        submit: 'login',
        title: 'Login',
        subtitle: 'Monitor, analyse, and optimise your energy consumption with confidence.',
        welcome: 'Welcome back! Please enter your details.',
        hero_title: 'Powering efficient energy management for modern utilities',
        highlight_1: 'Real-time dashboards and advanced analytics',
        highlight_2: 'Secure access tailored for your organisation',
        error: 'Email or password is incorrect',
        buttonNavigate: 'click here to reset password',
        success: 'Login success',
    },
    two_factor: {
        title: 'Verification required',
        submit: 'Verify',
        code: 'Verification code',
        error: 'Invalid or expired code. Please try again.',
        codeSent: 'Verification code sent to your email',
        welcome: 'A 6-digit code was sent to your email address.',
    },
    side_menu: {
        sites: 'Sites',
        users: 'Users',
        structures: 'Structures',
        meters: 'Meters',
        consumers: 'Consumers',
        rates: 'Rates',
        dashboard: 'Dashboard',
        meter_readings: 'Meter Readings',
        fault_logs: 'Fault Log',
        invoices: 'Invoice',
        account_reports: 'Account Report',
        invites: 'Invites',
        select_site: 'Select site',
        clear_site: 'Clear selection',
        payments: 'Payments',
        queue_jobs: 'Queue Jobs',
        categories: {
            management: 'Management',
            billing: 'Billing',
            system: 'System',
        },
    },
    dashboard: {
        currentRate: 'Current Rate',
        current_rate_subtitle: 'Active tariffs applied to your account.',
        readingsCard: {
            title: 'Meter reading overview',
            totalReadings: 'Total readings captured today',
            successRate: 'Success rate',
            lastUpdated: 'Last update',
            successful: 'Successful',
            failed: 'Failed',
        },
        invoices_cost_title: 'Cost Projection & Savings',
        invoices_cost_subtitle: 'Monthly invoice totals grouped by active accounts or consumers.',
        invoices_cost_empty: 'No invoice data available for this view.',
        invoices_cost_month_series: 'Monthly cost',
        invoices_cost_ytd_series: 'Cumulative cost',
        invoices_cost_ytd_title: 'Year-to-date total',
        noRateAvailable: 'No rate available',
    },
    sites: {
        _id: 'ID',
        name: 'Name',
        apiKey: 'Api Key',
        created: 'Created',
        updated: 'Updated',
        location: 'Location',
        dayOfMonth: 'Billing Day',
        createAccount: 'Create Account',
        editAccount: 'Edit Account',
        security: 'Security',
        isTwoFactorAuth: 'Require Two-Factor Authentication',
        rates: 'Rates',
        serviceRate: 'Service Rate',
        electricityRate: 'Electricity Rate',
        waterRate: 'Water Rate',
        gasRate: 'Gas Rate',
        payment: 'Payment',
        terminalName: 'Terminal Name',
        paymentProvider: 'Payment Provider',
        configs: 'Configurations',
        submit: {
            edit: {
                success: 'Site updated successfully',
                error: 'Error updating Site',
            },
            create: {
                success: 'Site created successfully',
                error: 'Error creating Site',
            },
        },
        delete: {
            success: 'Site deleted successfully',
            error: 'Error deleting Site',
        },
    },
    userAccounts: {
        title: 'User Site',
        account: 'Site',
        role: 'Role',
        confirmed: 'Confirmed',
    },
    users: {
        _id: 'ID',
        name: 'Name',
        email: 'Email',
        status: 'Status',
        role: 'Role',
        firstName: 'First Name',
        lastName: 'Last Name',
        phone: 'Phone',
        account: 'Site',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        createUser: 'Create User',
        userAccounts: 'User Sites',
        editUser: 'Edit User',
        users: 'Users',
        invites: 'Invites',
        submit: {
            edit: {
                success: 'User updated successfully',
                error: 'Error updating User',
            },
            create: {
                success: 'User created successfully',
                error: 'Error creating User',
            },
        },
        delete: {
            success: 'User deleted successfully',
            error: 'Error deleting User',
        },
    },
    structures: {
        _id: 'ID',
        name: 'Name',
        account: 'Site',
        location: 'Location',
        createStructure: 'Create Structure',
        editStructure: 'Edit Structure',
        submit: {
            edit: {
                success: 'Structure updated successfully',
                error: 'Error updating Structure',
            },
            create: {
                success: 'Structure created successfully',
                error: 'Error creating Structure',
            },
        },
        delete: {
            success: 'Structure deleted successfully',
            error: 'Error deleting Structure',
        },
    },
    meters: {
        _id: 'ID',
        name: 'Name',
        account: 'Site',
        structure: 'Structure',
        type: 'Type',
        input: 'Input',
        inputType: 'Input Type',
        meter: 'Meter Id',
        createMeter: 'Create Meter',
        consumer: 'Consumer',
        editMeter: 'Edit Meter',
        meterReading: 'Last Recorded',
        conversionRate: 'Conversion Rate',
        rolloverValue: 'Reset Value',
        settings: 'Settings',
        additionalCharges: 'Additional Charges',
        relationshipUpdates: 'Relationship Updates',
        consumerUpdateDate: 'Consumer update date',
        structureUpdateDate: 'Structure update date',
        consumerUpdateDateAction: 'Add consumer update date',
        structureUpdateDateAction: 'Add structure update date',
        updateDateTooltipWithValue: '{{field}} set to {{value}}. Click to change.',
        meterId: 'Meter Id',
        category: 'Category',
        active: 'Active',
        provider: 'Provider',
        submit: {
            edit: {
                success: 'Meter updated successfully',
                error: 'Error updating Meter',
            },
            create: {
                success: 'Meter created successfully',
                error: 'Error creating Meter',
            },
        },
        delete: {
            success: 'Meter deleted successfully',
            error: 'Error deleting Meter',
        },
        sync: {
            success: 'Meter sync triggered',
            error: 'Error triggering meter sync',
        },
        syncZeusintDaily: 'Sync Zeusint Daily',
        syncZeusintDailySuccess: 'Zeusint daily sync triggered',
        syncZeusintDailyError: 'Error triggering Zeusint daily sync',
        error: {
            charge_key_max: 'Charge name must be 100 characters or less',
            duplicate_charge_key: 'Charge names must be unique (case-insensitive)',
        },
    },
    consumers: {
        _id: 'ID',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        account: 'Site',
        structure: 'Structure',
        charging_date: 'Charging Date',
        taoz: 'Taoz',
        meter: 'Meter',
        location: 'Location',
        createConsumer: 'Create Consumer',
        last_invoice_date: 'Last Invoice Date',
        payment: 'Payment',
        send_unpaid_invoices: {
            success: 'Unpaid invoices reminder sent successfully',
            error: 'Error sending unpaid invoices reminder',
            confirm: 'Are you sure you want to send unpaid invoices reminder to this consumer?',
        },
        submit: {
            edit: {
                success: 'Consumer updated successfully',
                error: 'Error updating Consumer',
            },
            create: {
                success: 'Consumer created successfully',
                error: 'Error creating Consumer',
            },
        },
        delete: {
            success: 'Consumer deleted successfully',
            error: 'Error deleting Consumer',
        },
    },
    rates: {
        _id: 'ID',
        rate: 'Rate',
        monthStart: 'Month Start',
        monthEnd: 'Month End',
        hourStart: 'Hour Start',
        hourEnd: 'Hour End',
        months: 'Months',
        hours: 'Hours',
        typeDay: 'Type Day',
        status: 'Status',
        account: 'Site',
        name: 'name',
        rateSection: 'Create Rate',
        editRate: 'Edit Rate',
        settings: 'Settings',
        isGlobal: 'Global',
        category: 'Meter Category',
        dateAndTimeSection: 'Date and Time',
        calendar: {
            action: 'Create via calendar',
            title: 'Create Rate (Calendar)',
            instructions:
                'Select the months and hours for this rate by clicking and dragging across the grid.',
            tips: {
                drag: 'Drag to cover a range',
                remove: 'Right-click drag to subtract a range',
            },
            form: {
                settingsTitle: 'Rate configuration',
                settingsHint:
                    'Choose the account, category, and other parameters before drawing on the calendar.',
                infoTitle: 'Calendar snapshot',
                infoHint: 'Totals update automatically as you add or remove cells.',
                selectionLabel: 'Pending slots',
                lockedLabel: 'Locked slots',
                hoverLabel: 'Highlighted locked slots',
                summaryTitle: 'Selection summary',
                emptySummary: 'No slots selected yet.',
                hoverHint:
                    'Grey cells mark active rates. Hover to preview the full range or click to manage the rate.',
            },
            legend: {
                active: 'Selected range',
                previewAdd: 'Drag to add',
                previewRemove: 'Drag to remove',
            },
            selection: {
                empty: 'Choose a time range to see the summary here.',
                single: 'Selected {{month}} at {{hour}}.',
                sameMonth: 'Selected {{month}} from {{startHour}} to {{endHour}}.',
                multiMonth:
                    'Selected {{startMonth}} {{startHour}} through {{endMonth}} {{endHour}}.',
                count: '{{count}} time slots selected (first: {{month}} {{hour}}).',
            },
            clear: 'Clear selection',
            save: 'Save rate',
            saving: 'Saving...',
            cancel: 'Cancel',
            gridTitle: 'Monthly & hourly availability',
            aria: {
                grid: 'Rate calendar grid. Drag to select the applicable months and hours.',
                cell: '{{month}} at {{hour}}',
            },
            lockedRate: {
                title: 'Existing rate',
                description: 'This time range belongs to an existing active rate.',
                typeDay: 'Day type',
                rate: 'Rate: {{value}}',
                months: 'Months',
                hours: 'Hours',
                disable: 'Deactivate rate',
                disabling: 'Updating rate…',
                disableSuccess: 'Rate deactivated successfully.',
                disableError: 'Failed to deactivate rate.',
                none: 'None',
                tooltipTitle: 'Active rate',
                tooltipRate: 'Rate: {{value}}',
                tooltipDay: 'Day type: {{value}}',
            },
            preview: {
                actionButton: 'Preview calendar',
                title: 'Rates calendar preview',
                subtitle: 'Filter and explore configured electricity rates without editing.',
                filtersTitle: 'Preview filters',
                accountLabel: 'Account',
                allAccounts: 'All accounts',
                typeDayLabel: 'Type day',
                rateNameLabel: 'Rate name',
                noRateSelected: 'No rate selected',
                allRates: 'All rate names',
                clearRates: 'Clear selection',
                selectAllRates: 'Select all',
                isGlobalLabel: 'Scope',
                isGlobalAll: 'All rates',
                isGlobalOnly: 'Global rates only',
                isGlobalLocal: 'Account rates only',
                resultsSummary: '{{count}} matching rates',
                noRatesTitle: 'No rates found',
                noRatesDescription:
                    'Try a different combination of filters to see configured rates on the calendar.',
                dialogTitle: 'Rate details',
                dialogDescription: 'This rate is shown in preview mode.',
            },
        },
        submit: {
            edit: {
                success: 'Rate updated successfully',
                error: 'Error updating Rate',
            },
            create: {
                success: 'Rate created successfully',
                error: 'Error creating Rate',
            },
        },
        delete: {
            success: 'Rate deleted successfully',
            error: 'Error deleting Rate',
        },
        global_label: 'Global rate',
    },
    meter_readings: {
        _id: 'ID',
        account: 'Site',
        meter: 'Meters',
        structure: 'Structure',
        date: 'Date',
        value: 'Value',
        absolute_value: 'Absolute Value',
        price: 'Price',
        name: 'name',
        is_new_meter: 'New meter replacement',
        newMeterShort: 'New meter',
        createMeterReading: 'Create Meter Reading',
        editMeterReading: 'Edit Meter Reading',
        failure_details: 'Failure Details',
        status: 'Status',
        submit: {
            edit: {
                success: 'Meter Reading updated successfully',
                error: 'Error updating Meter Reading',
            },
            create: {
                success: 'Meter Reading created successfully',
                error: 'Error creating Meter Reading',
            },
        },
        updateValue: {
            success: 'Meter Reading updated successfully',
            error: 'Error updating Meter Reading',
        },
        newMeter: {
            confirmMark: 'Mark this reading as a new meter replacement? The consumption will be set to 0.',
            confirmUnmark: 'Remove the new meter flag from this reading?',
            marked: 'Marked as new meter replacement',
            unmarked: 'New meter flag removed',
            error: 'Error updating meter reading',
        },
        delete: {
            success: 'Meter Reading deleted successfully',
            error: 'Error deleting Meter Reading',
        },
        export: {
            title: 'Export to Excel',
            button: 'Export',
            from_date: 'From date',
            to_date: 'To date',
            success: 'File exported successfully',
            error: 'Error exporting file',
        },
    },
    invoices: {
        account: 'Site',
        consumer: 'Consumer',
        meter: 'Meter',
        from_date: 'From Time',
        to_date: 'To Time',
        send_mail: 'Send Mail',
        created: 'Created',
        total_price: 'Price',
        createInvoice: 'Create Invoice',
        downland: {
            success: 'Invoice downloaded successfully',
            error: 'Error downloading Invoice',
        },
        is_paid: 'Paid',
        createPdfSuccess: 'Pdf created successfully',
        is_change_status: 'Change Status',
        createPdfError: 'Error creating Pdf',
        resend: {
            success: 'Invoice resent successfully',
            error: 'Error resending Invoice',
            confirm: 'Are you sure you want to resend this invoice?',
        },
        cancel: {
            success: 'Invoice canceled successfully',
            error: 'Error canceling Invoice',
            confirm: 'Are you sure you want to cancel this invoice?',
        },
        cancelled_status: 'Cancelled invoice',
        invoice_number: 'Invoice Number',
        creation_method: 'Creation Method',
        number: 'Invoice Number',
        submit: {
            edit: {
                success: 'Invoice updated successfully',
                error: 'Error updating Invoice',
            },
            create: {
                success: 'Invoice created successfully',
                error: 'Error creating Invoice',
            },
        },
        delete: {
            success: 'Invoice deleted successfully',
            error: 'Error deleting Invoice',
        },
        is_paid_status: {
            true: 'Paid',
            false: 'Not Paid',
            confirm_text: {
                paid: 'Yes, mark as paid',
                unpaid: 'Yes, mark as unpaid',
            },
            close_modal_title: {
                paid: 'Are you sure you want to mark the invoice as paid?',
                unpaid: 'Are you sure you want to mark the invoice as unpaid?',
            },
            success: {
                paid: 'Invoice marked as paid',
                unpaid: 'Invoice marked as unpaid',
            },
        },
    },
    queue_jobs: {
        id: 'Job ID',
        name: 'Name',
        state: 'State',
        progress: 'Progress',
        attemptsMade: 'Attempts',
        processedOn: 'Processed',
        finishedOn: 'Finished',
        failedReason: 'Failed reason',
    },
    fault_logs: {
        _id: 'ID',
        account: 'Site',
        meter: 'Meter',
        structure: 'Structures',
        created: 'Date fualt',
        message: 'Message',
        error: 'Error',
        submit: {
            edit: {
                success: 'Fault Log updated successfully',
                error: 'Error updating Fault Log',
            },
            create: {
                success: 'Fault Log created successfully',
                error: 'Error creating Fault Log',
            },
        },
        delete: {
            success: 'Fault Log deleted successfully',
            error: 'Error deleting Fault Log',
        },
        resolveFault: {
            success: 'Fault resolved successfully',
            error: 'Error resolving Fault',
        },
    },
    invites: {
        email: 'Email',
        account: 'Site',
        role: 'Role',
        expireTime: 'Token Time Left',
        inviteUser: 'Invite User',
        sendAgainSuccess: 'Invite sent successfully',
        sendAgainError: 'Error sending invite',
        sendAgain: {
            success: 'Invite sent successfully',
            error: 'Error sending invite',
        },
    },
    payments: {
        account: 'Site',
        amount: 'Amount',
        currency: 'Currency',
        created: 'Created',
        status: 'Status',
        invoice: 'Invoice',
        tokenExpiresAt: 'Token Expires',
        refreshToken: {
            confirm: 'Are you sure you want to generate a new payment token?',
            success: 'Payment token refreshed successfully',
            error: 'Error refreshing payment token',
        },
    },
    selectOptions: {
        manual: 'Manual',
        monthly: 'Monthly',
        bi_monthly: 'Bi Monthly',
        pisga: 'Pisga',
        sheffel: 'Sheffel',
        weekday: 'Weekday',
        friday: 'Friday and Holiday Eves',
        saturday: 'shabbat and Holidays',
        OWNER: 'OWNER',
        ADMIN: 'ADMIN',
        USER: 'USER',
        ACTIVE: 'ACTIVE',
        INACTIVE: 'INACTIVE',
        CANCELLED: 'Cancelled',
        pending: 'Pending',
        paid: 'Paid',
        unpaid: 'Unpaid',
        general: 'General',
        water: 'Water',
        electricity: 'Electricity',
        gas: 'GAS',
        constant: 'Constant',
        geva: 'Geva',
        failed: 'Failed',
        waiting: 'Waiting',
        active: 'Active',
        delayed: 'Delayed',
        completed: 'Completed',
        auto: 'Automatic',
        error_saving_meter_reading_from_webhook: 'Error saving meter reading from webhook',
        repeated_meter_failure_notification: 'Repeated meter failure notification',
        assigned: 'Assigned',
        success: 'Success',
        canceled: 'Canceled',
    },
    date: {
        from: 'From Date',
        to: 'To Date',
    },
    modal: {
        close_modal_title: 'Are you sure you want to close?',
        confirm_close_modal: 'Yes, Close',
        modal_error_title: 'Something went wrong!',
        confirm_title: 'Attention',
        confirm_action: 'Yes, Confirm',
        delete_title: 'Are you sure you want to delete?',
        confirm_delete: 'Yes, Delete',
        cancel: 'Cancel',
        clear: 'Clear',
        delete_success: 'Deleted successfully',
        submit: 'Submit',
    },
    error: {
        Required: 'This field is required',
        required: 'This field is required',
        min: 'Minimum length',
        max: 'Maximum length',
        email: 'Please enter a valid email',
        password: 'Password must be at least 6 characters long',
        name: 'Name is required',
        location: 'Location is required',
        dayOfMonth: 'Day of month must be between 1 and 31',
        serviceRate: 'Service rate must be between 0 and 100',
        account: 'Please select an account',
        structure: 'Please select a structure',
        meter: 'Please select a meter',
        consumer: 'Please select a consumer',
        rate: 'Please select a rate',
        value: 'Please enter a valid value',
        absolute_value: 'Please enter a valid absolute value',
        price: 'Please enter a valid price',
        date: 'Please enter a valid date',
        from_date: 'Please enter a valid from date',
        to_date: 'Please enter a valid to date',
        phone: 'Please enter a valid phone number',
        role: 'Please select a role',
        status: 'Please select a status',
        type: 'Please select a type',
        category: 'Please select a category',
        config_key_max: 'Key must be 100 characters or less',
        duplicate_config_key: 'Keys must be unique (case-insensitive)',
        charge_key_max: 'Charge name must be 100 characters or less',
        duplicate_charge_key: 'Charge names must be unique (case-insensitive)',
    },
    signup: {
        title: 'Sign up',
        submit: 'Submit',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        firstName: 'First Name',
        lastName: 'Last Name',
        phone: 'Phone Number',
        language: 'Language',
        success: 'Signup success',
    },
    forgotPassword: {
        title: 'Forgot Password',
        submit: 'Submit',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        buttonNavigate: 'click here to login',
        success: 'Link sent to your email',
        welcome: 'Please enter your details.',
    },
    pullToRefresh: {
        pulling: 'Pull down to refresh',
        refreshing: 'Refreshing...',
    },
    loading: 'Loading...',
    menuItems: {
        language: 'Language',
        messages: 'Messages',
        notifications: 'Notifications',
        profile: 'Profile',
        queue: 'Queue Management',
        darkMode: 'Dark Mode',
        lightMode: 'Light Mode',
    },
    filters: {
        account: 'Site',
        structure: 'Structure',
        meter: 'Meter',
        consumer: 'Consumer',
        rate: 'Rate',
        user: 'User',
        category: 'Category',
        status: 'Status',
        typeDay: 'Type Day',
        isGlobal: 'Global',
        taoz: 'Taoz',
        role: 'Role',
        date: 'Date',
        from_date: 'From Date',
        to_date: 'To Date',
        error: 'Errors',
        provider: 'Provider',
        allCategories: 'All categories',
        status_paid: 'Payment Status',
    },
    configs: {
        title: 'Configuration',
        key: 'Key',
        value: 'Value',
    },
    settings: {
        general: 'General',
        info: 'Information',
        queues: 'Queues',
        generalSettings: {
            rolloverValue: 'Rollover Value',
            percentRolloverValue: 'Percent Rollover Value',
            errors: 'Errors',
            numberOfReadingsFailure: 'Number of Readings Failure',
            numberOfDaysReadingsMissing: 'Number of Days Readings Missing',
            queueEnabled: 'Enable Queue Processing',
        },
        queueManagement: {
            healthTitle: 'Queue Health',
            refresh: 'Refresh',
            lastUpdated: 'Last updated',
            statusRunning: 'Running',
            statusPaused: 'Paused',
            waiting: 'Waiting',
            active: 'Active',
            failed: 'Failed',
            completed: 'Completed',
            jobsTitle: 'Jobs',
            selectQueue: 'Select queue',
            stateFilter: 'States',
            noJobs: 'No jobs found',
            state: 'State',
            progress: 'Progress',
            attempts: 'Attempts',
            processedOn: 'Processed',
            finishedOn: 'Finished',
            failedReason: 'Failed reason',
            data: 'Data',
            filters: 'Filters',
            autoRefresh: 'Auto Refresh',
            completionRate: 'Completion Rate',
            queues: 'Queues',
            actions: {
                pause: 'Pause',
                resume: 'Resume',
                clear: 'Clear',
                cancel_job: 'Cancel Job',
                retry_job: 'Retry Job',
            },
            actionSuccess: '{{action}} command sent',
            actionError: 'Failed to {{action}} queue',
            cancelJobSuccess: 'Job cancelled successfully',
            cancelJobError: 'Failed to cancel job',
            retryJobSuccess: 'Job queued for retry',
            retryJobError: 'Failed to retry job',
        },
        submit: {
            edit: {
                success: 'Settings updated successfully',
                error: 'Error updating Settings',
            },
            create: {
                success: 'Settings created successfully',
                error: 'Error creating Settings',
            },
        },
    },
    permissions: {
        title: 'Custom permissions',
        userLabel: 'User',
        accountLabel: 'Account',
        roleLabel: 'Role',
        roleFallback: 'Not set',
        resourcesLabel: 'Resource',
        unknownUser: 'Unknown user',
        unknownAccount: 'Unknown account',
        roleInheritance: 'Inherited from {{role}}',
        superUserNotice:
            'This user is a super user. Custom permissions only affect the UI, backend restrictions still apply.',
        noAccounts: 'Assign the user to at least one account to manage permissions.',
        loadError: 'Unable to load permissions. Please try again.',
        currentValue: 'Update the allowed actions and save the override.',
        searchPlaceholder: 'Search resources',
        badges: {
            inherited: 'Role default',
            override: 'Custom override',
            unsaved: 'Unsaved changes',
            enabledCount: '{{enabled}}/{{total}} enabled',
        },
        summary: {
            pendingChanges: '{{count}} resource(s) modified',
            noChanges: 'No pending changes',
            enabledCount: '{{enabled}}/{{total}} actions',
        },
        emptyState: {
            noMatches: 'No resources match your search.',
            selectResource: 'Select a resource to review its permissions.',
            missingCatalog: 'Resource metadata is unavailable.',
            noActions: 'No configurable actions for this resource.',
            noResources: 'No resources are available for this account.',
        },
        confirm: {
            unsaved: 'You have unsaved changes. Continue without saving?',
        },
        actions: {
            save: 'Save changes',
            clearOverride: 'Use role defaults',
            selectAll: 'Enable all',
            clearAll: 'Disable all',
            matchRole: 'Match role default',
            saveAll: 'Save all',
            discard: 'Discard changes',
        },
        actionLabels: {
            CREATE: 'Create',
            READ: 'Read',
            UPDATE: 'Update',
            DELETE: 'Delete',
            ADMIN: 'Admin',
            OWNER: 'Owner',
            SUPER: 'Super',
        },
        resources: {
            USERS: 'Users',
            ACCOUNTS: 'Accounts',
            METERS_READING: 'Meter Readings',
            INVOICES: 'Invoices',
            RATES: 'Rates',
            CONSUMERS: 'Consumers',
            FAULT_LOG: 'Fault Log',
            CONFIGS: 'Configurations',
            ACCOUNT_REPORTS: 'Account Reports',
            INVITES: 'Invites',
            METERS: 'Meters',
            STRUCTURES: 'Structures',
            PAYMENTS: 'Payments',
        },
        toast: {
            save: {
                success: 'Permissions updated successfully',
                error: 'Failed to update permissions',
            },
            reset: {
                success: 'Permissions reverted to role defaults',
                error: 'Failed to reset permissions',
            },
            bulk: {
                success: 'Permissions updated',
                error: 'Failed to update permissions',
            },
        },
    },
    paymentFlow: {
        title: 'Invoice payment',
        subtitle: 'Complete your payment securely using the form below.',
        missingToken: 'This payment link is invalid or has expired. Please contact support.',
        result: {
            pending: 'Payment is pending',
            paid: 'Payment complete',
            failed: 'Payment failed',
            success: 'Payment complete',
            unknown: 'Payment status unavailable',
        },
        iframe: {
            title: 'Secure payment form',
            subtitle: 'If the form does not load, refresh the page or try again later.',
        },
        details: {
            paymentId: 'Payment ID',
            amount: 'Amount',
            invoice: 'Invoice',
        },
        actions: {
            refresh: 'Refresh status',
        },
        errors: {
            status: 'Unable to load payment information.',
        },
    },
    save: 'Save',
    profile: {
        title: 'Profile',
        image: 'Upload Image',
        saveChanges: 'Save Changes',
    },
    fromDialogActions: {
        overview: 'Overview',
    },
    menuItem: {
        download: 'Download',
        update_value: 'Update Value',
        send_again: 'Send Again',
        resend_invoice: 'Resend Invoice',
        cancel_invoice: 'Cancel Invoice',
        send_unpaid_invoices: 'Send Unpaid Invoices',
        edit: 'Edit',
        delete: 'Delete',
        resolve_fault: 'Resolve Fault',
        manage_permissions: 'Manage Permissions',
        open_payment: 'Open Payment',
        refresh_payment_token: 'Refresh Payment Token',
        sync_meter: 'Sync Meter',
        cancel_job: 'Cancel Job',
        retry_job: 'Retry Job',
        mark_new_meter: 'Mark as New Meter',
        unmark_new_meter: 'Unmark New Meter',
    },
    failure_details: {
        rate: 'No Rate',
        price: 'No Price',
        reading_exist: 'Reading Exist',
        absolute_value: 'No Absolute Value',
        invoice_date: 'Invoice created',
    },
    table: {
        header: {
            filter: 'Filter',
            add: 'Add New',
        },
    },
    additionalCharges: {
        chargeKey: 'Charge Name',
        chargeValue: 'Charge Amount',
    },
    notFound: {
        title: '404',
        subtitle: 'Page not found',
        description: "The page you are looking for doesn't exist or has been moved.",
        backToDashboard: 'Back to Dashboard',
    },
}

export default en
